<lgb-header-gradient [background]="true"></lgb-header-gradient>
<div class="screen-container" [loading]="loading()">
	<h1 class="mb-4">Api Keys</h1>
	<div class="mb-2">
		<lgb-message [(error)]="error" [(msg)]="msg"></lgb-message>
	</div>
	<ul class="list bg-base-100 rounded-box shadow-md">
	  <li class="header-container p-4 pb-2 text-xs opacity-60 tracking-wide">
	  	<span>Liste des Api Key</span>
		<a (click)="modal.showModal()" class="btn btn-square btn-ghost add-btn text-primary">
			<i class="fa-regular fa-layer-plus"></i>
		</a>
	  </li>
	  
	  @for(key of keys(); track key.ident){
		  <li class="list-row">
		    <div class="list-row-element">
		      <div>{{key.app}}</div>
		    </div>
		    <div class="list-row-element">
		      <span class="badge badge-soft badge-sm text-xs font-semibold opacity-60" [ngClass]="getClass(key)">
		      	{{key.state}}
		      </span>
		    </div>
		    <a [copy]="key.key" copyMsg="Api Key copiée." class="btn btn-square btn-ghost">
		      <i class="text-primary fa-regular fa-copy"></i>
		    </a>
		    @if(key.state!='disabled'){
			    <a (click)="disableKey(key)" class="btn btn-square btn-ghost">
			    	<i class="text-primary fa-regular fa-link-simple-slash"></i>
			    </a>
			}
			@else{
			    <button class="btn btn-square btn-ghost" disabled>
			    	<i class="fa-regular fa-link-simple-slash"></i>
			    </button>
			}
		    <a (click)="removeKey(key)" class="btn btn-square btn-ghost">
		    	<i class="text-error fa-light fa-trash-can"></i>
		    </a>
		  </li>
	  }
	  @empty{
	  	 <li class="list-row">
		    <div>
		      <div>Aucune Api key</div>
		  </div>
		</li>
	  }
	</ul>

	<dialog #modal id="my_modal_1" class="modal">
	  <div class="modal-box">
	    <div>
	    	Génération de l'Api Key
	    </div>
	    <div>
			<!-- qte -->
			<label class="floating-label my-4">
			  <span>App name</span>
			  <input type="text" [(ngModel)]="app" placeholder="App name" name="appName" class="input input-md w-full" required />
			</label>
	    </div>
	    <div class="modal-action">
	      <form method="dialog">
	        <!-- if there is a button in form, it will close the modal -->
	        <button class="btn">Annuler</button>
	        <button (click)="addApiKey()" class="btn btn-primary btn-gradient">Valider</button>
	      </form>
	    </div>
	  </div>
	</dialog>
</div>
